module.exports = __webpack_public_path__ + "img/icon-wm-2.c6b6b6db.svg";